import { css as o, styled as s } from "@lokalise/styled";
const e = o`
	pointer-events: all;
	box-sizing: border-box;
	color: var(--louis-svgicon-color);
	fill: currentColor;
	font-size: var(--louis-svgicon-size);
`, r = s.svg`
	${e};
	width: 1em;
	height: 1em;
`;
export {
  r as SvgRoot
};
//# sourceMappingURL=styles.js.map
